import React from "react";

interface ImageProps {
  src: string;
  alt: string;
  borderRadius?: number | string;
  width?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  height?: number;
  objectFit?: "contain" | "cover" | "fill";
  testID?: string;
}

/**
 * Renders the image with given URL.
 */
export function Image(props: ImageProps) {
  const {
    borderRadius,
    objectFit,
    src,
    alt,
    width = "100%",
    maxWidth = "100%",
    maxHeight,
    height,
    testID,
  } = props;

  return (
    <img
      data-component="Image"
      data-testid={testID}
      src={src}
      alt={alt}
      style={{ width, maxWidth, maxHeight, height, borderRadius, objectFit }}
    />
  );
}
